// react
import React, { useState, useContext} from 'react';
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';


// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Edit from "@material-ui/icons/Edit";

// @material-ui components
import Tooltip from "@material-ui/core/Tooltip";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Credenciamento from "./Credenciamento";
import Badge from "beaktShared/components/Badge/Badge.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// services
import { useGetApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function CredenciamentoList({history, callUpdateScrollTOP}) {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});
    const [loadingEdit, setLoadingEdit] = useState(false);

    const [notification, setNotification] = React.useState({
        show: false,
        color: 'info',
        message: ''
    });
    const showNotification = (message, color) => {
        setNotification({
            show: true,
            color: color,
            message: message
        });
        setTimeout(function () {
            setNotification({ show: false });
        }, 6000);
    };

    const getEndPoint = () => {
        let endPointGet = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet =  "estabelecimentos/byfranquia/"+ session.franquiaId;
        return  endPointGet;
    }
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());
    
    const handleView = (resetItem, item) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);  
        callUpdateScrollTOP();
        
        if(!item)
            return;

        var vefifyExists = list.filter(obj => {
            return obj.estabelecimentoId === item.estabelecimentoId;
        });

        if(vefifyExists.length > 0)
        {           
            const updateList = list.map(l => (l.estabelecimentoId === item.estabelecimentoId ? item : l));
            setListAtualiza(updateList);                     
        }
        else
        {      
            const addItemList = [...list, item];
            setListAtualiza(addItemList); 
        }
    };

    const handleEdit = row => {
        setLoadingEdit(true);
        UseGetApiSimple("estabelecimentos/" + row.estabelecimentoId).then(result => {
            setLoadingEdit(false);
            if (!result || result.status !== 200) {
                showNotification(t('error_message.loading_error'), 'danger');
                return false;
            }
            setItem(result.data);
            handleView(false);
        });
    };

    const columnsProp = [
    {
        Header: t('label.cnpj'),
        accessor: "cnpjcpf",
    },
    {
        Header: t('label.fantasy'),
        accessor: "descricao",
    },
    {
        Header: t('label.responsible'),
        accessor: "nomeResponsavel",
    },
    {
        Header: t('label.city'),
        accessor: "cidade",
    },
    {
        Header: t('label.state'),
        accessor: "estado",
    },
    {
        Header: t('label.status'),
        Cell: row => ( <span> { row.original.ativo ? <Badge color="success">{t('label.active')}</Badge> :<Badge color="danger">{t('label.inactive')} </Badge> } </span>),
        accessor: "ativo",
        filterable: false
    },
    {
        Header: t('accreditation.registration_status'),
        Cell: row => ( <span> { row.original.isCadastroCompleto ? <strong className="font-weight-bold">{t('label.complete')}</strong> :<strong className="font-weight-bold text-danger">{t('label.incomplete')} </strong>} </span>),
        filterable: false
    }]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">   
                                   
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    disabled={loadingEdit}
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>      
                          
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
    <div>

        <Snackbar
            place="tr"
            color={notification.color}
            message={notification.message}
            open={notification.show}
            closeNotification={() => setNotification({ show: false })}
            close
        />

        {!showFormView &&
        <GridContainer>            
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>{t('accreditation.list_of_accredited')} </h4>
                    </CardHeader>
                    <CardBody>
                        <Button
                            color="primary"
                            className={classes.newButton}
                            onClick={() => handleView(true)}
                        >
                            {t('button.new')}
                        </Button>                           

                        {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                        <ReactTable
                            loading = {isLoadingList}
                            data={list}
                            filterable
                            defaultFilterMethod = {noCaseSensitive}
                            columns={columns}
                            defaultPageSize={10}
                            minRows={5}
                            showPaginationBottom={true}
                            className="-striped -highlight"
                            previousText={t('button.previous')}
                            nextText={t('button.next')}
                            loadingText={t('label.loading')+"..."}
                            noDataText={t('information_message.no_records_found')+"!"}
                            pageText={t('label.page')}
                            ofText={t('label.of')}
                            rowsText={t('label.rows')}
                        />
                    </CardBody>
                </Card>
            </GridItem>            
        </GridContainer>
        }     

        
        {showFormView && 
            <Credenciamento item={item} handleView={handleView} history={history} />}    
    </div>
    );
}
